module.exports = __webpack_public_path__ + "static/media/18ECA8.0c6d015b.jpg";